// src/components/programs/ShowProgram/SettledMissingJobOrdersModal.jsx
import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, IconButton, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Close, Warning } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const SettledMissingJobOrdersModal = ({ open, onClose, programId, missingCount, onSettleAnyway, isClosing }) => {
    const { i18n } = useTranslation();
    const isArabic = i18n.language === "ar";
    const navigate = useNavigate();

    const handleCompleteMissing = () => {
        onClose();
        navigate(`/programs/${programId}/job-orders?missing=true`);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: 'error.main' }}>
                <Box display="flex" alignItems="center" gap={1}>
                    <Warning />
                    {isArabic ? "أوامر التشغيل المفقودة" : "Missing Job Orders"}
                </Box>
                <IconButton onClick={onClose} size="small">
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant="body1" mb={2}>
                    {isArabic
                        ? `يوجد ${missingCount} خدمة ضمن البرنامج لم يتم إصدار أمر تشغيل (Job Order) لها.`
                        : `There are ${missingCount} services in this program that do not have a Job Order issued.`}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    {isArabic
                        ? "يُنصح بإكمال أوامر التشغيل لجميع الخدمات قبل إغلاق البرنامج (Settled). هل ترغب بالانتقال لصفحة أوامر التشغيل، أم إغلاق البرنامج على أية حال؟"
                        : "It is recommended to complete job orders for all services before settling the program. Do you want to go to the Job Orders page, or settle anyway?"}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={isClosing}>
                    {isArabic ? "إلغاء" : "Cancel"}
                </Button>
                <Button onClick={onSettleAnyway} color="error" disabled={isClosing}>
                    {isClosing ? (isArabic ? "جاري التحميل..." : "Loading...") : (isArabic ? "إغلاق البرنامج على أي حال" : "Settle Anyway")}
                </Button>
                <Button onClick={handleCompleteMissing} variant="contained" color="primary" disabled={isClosing}>
                    {isArabic ? "الذهاب لأوامر التشغيل والفاوتشر" : "Go to Job Orders & Vouchers"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SettledMissingJobOrdersModal;
